export enum GameEvent {
  VICTORY_ROAD = "VICTORY_ROAD",
  EXPEDITIONS = "EXPEDITIONS"
}

export const GameEvents: GameEvent[] = [
  GameEvent.VICTORY_ROAD,
  GameEvent.EXPEDITIONS
]
